import { Link } from "react-router-dom"
import "./style.css"

const bookCovers = [
  "/img/img_index/1984.webp",
  "/img/img_index/percy - mar de monstros.jpg",
  "/img/img_index/percy - maldicao do tita.jpg",
  "/img/img_index/percy - o ultimo olimpiano.jpg",
  "/img/img_index/percy - a maldicao do tita 2.jpg",
  "/img/img_index/herry - a pedra filosofal.jpg",
  "/img/img_index/harry - a ordem de fenix.jpg",
  "/img/img_index/harry - enigma do principe.jpg",
  "/img/img_index/assim que acaba.jpeg",
  "/img/img_index/percy - e os olimpianos.jpg",
  "/img/img_index/percy - a batalha do labirinto.jpg",
  "/img/img_index/biblioteca da meia noite.jpg",
  "/img/img_index/diario de anne frank.jpg",
  "/img/img_index/harry - o calice de fogo.jpg",
  "/img/img_index/percy - ladrao de raios.jpg",
  "/img/img_index/harry - e a camara secreta.jpg",
  "/img/img_index/harry - as reliquias da morte.jpg",
  "/img/img_index/harry - prsioneiro de azkaban.jpg",
]

const col1 = bookCovers.slice(0, 5)
const col2 = bookCovers.slice(5, 10)
const col3 = bookCovers.slice(10, 14)
const col4 = bookCovers.slice(14, 18)

export function Welcome() {
  return (
    <main className="welcome-root">
      {/* Background book mosaic */}
      <div className="welcome-mosaic" aria-hidden="true">
        <div className="mosaic-fade-left" />
        <div className="mosaic-fade-right" />
        <div className="mosaic-fade-bottom" />
        <div className="mosaic-col mosaic-col--1">
          {[...col1, ...col1].map((src, i) => (
            <img key={i} src={src} alt="" className="mosaic-img" />
          ))}
        </div>
        <div className="mosaic-col mosaic-col--2">
          {[...col2, ...col2].map((src, i) => (
            <img key={i} src={src} alt="" className="mosaic-img" />
          ))}
        </div>
        <div className="mosaic-col mosaic-col--3">
          {[...col3, ...col3].map((src, i) => (
            <img key={i} src={src} alt="" className="mosaic-img" />
          ))}
        </div>
        <div className="mosaic-col mosaic-col--4">
          {[...col4, ...col4].map((src, i) => (
            <img key={i} src={src} alt="" className="mosaic-img" />
          ))}
        </div>
      </div>

      {/* Hero content */}
      <div className="welcome-hero">
        <div className="welcome-badge">
          <span className="badge-dot" />
          Sua estante digital
        </div>

        <h1 className="welcome-title">
          Read<span className="welcome-title-accent">Books</span>
        </h1>

        <p className="welcome-subtitle">
          Registre, acompanhe e explore todos os livros que você leu ou está lendo.
          Sua jornada literária em um só lugar.
        </p>

        <div className="welcome-stats">
          <div className="stat-item">
            <span className="stat-number">∞</span>
            <span className="stat-label">livros</span>
          </div>
          <div className="stat-divider" />
          <div className="stat-item">
            <span className="stat-number">100%</span>
            <span className="stat-label">seu</span>
          </div>
          <div className="stat-divider" />
          <div className="stat-item">
            <span className="stat-number">0</span>
            <span className="stat-label">esquecidos</span>
          </div>
        </div>

        <div className="welcome-actions">
          <Link to="/cadastro" className="btn-primary-welcome">
            Criar conta gratuita
          </Link>
          <Link to="/login" className="btn-ghost-welcome">
            Entrar
          </Link>
        </div>

        <a
          href="https://play.google.com/store/apps/details?id=com.joaoenrique13.readbooks"
          target="_blank"
          rel="noreferrer"
          className="download-link"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 16l-4-4 1.41-1.41L11 13.17V8h2v5.17l1.59-1.58L16 13l-4 4z"/>
            <path d="M20 18H4v2h16v-2z"/>
          </svg>
          Baixar para Android
        </a>
      </div>
    </main>
  )
}